import { get, post } from 'edrolo/domains/net';
import urlResolver from 'edrolo/utils/URLResolver';

export function loadBookmarks(userId, classId) {
  const url = urlResolver.reverse('api:class-bookmarks', { userId, classId });
  return get(url, {
    transformBody: (body) => body.toJS(),
  });
}

export function saveBookmark(chunkId, data, deleteBookmark = false) {
  const url = urlResolver.getPath('ajax:bookmark');
  const updateData = data || {};
  updateData.chunk_pk = chunkId;
  updateData.object_id = chunkId;
  if (deleteBookmark) {
    // needs a valid form to delete for some reason
    updateData.reason = 'revisit';
    updateData.action = 'delete';
  }
  return post(url, updateData, {
    transformRequest: (request) => request.type('form'),
    transformBody: (body) => body.toJS(),
  });
}
